var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { MENU_GALAXY_EVENT_INPUT } from './Search.constant';
import { getComponentClassName } from './Search.functions';
import './Search.scss';
/**
 * Search component
 */
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    /**
     * Search constructor
     *
     * @param props
     */
    function Search(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Display result of search
         *
         * @param event
         */
        _this.receivedSearchResult = function (event // can't use Event or CustomEvent
        ) {
            if (event.detail.context === 'search' && event.detail.action === 'contentLoaded') {
                _this.setState({
                    componentClassName: getComponentClassName(_this.state.searchOpen, false),
                });
            }
        };
        /**
         * Handle click
         */
        _this.handleClick = function () {
            var searchOpen = _this.state.searchOpen;
            if (searchOpen && _this.searchString && _this.searchString.length && _this.lastSearch !== _this.searchString) {
                _this.submitSearch(_this.searchString);
            }
            else {
                _this.toggleSearchComponent(searchOpen);
                if (!searchOpen) {
                    setTimeout(function () { return (_this.inputSearch ? _this.inputSearch.focus() : undefined); }, 250);
                }
            }
        };
        /**
         * Handle key press
         *
         * @param evt
         */
        _this.handleKeyUp = function (evt) {
            if (evt.key === 'Enter') {
                _this.submitSearch(_this.searchString);
            }
            else if (evt.key === 'Escape') {
                _this.toggleSearchComponent(true);
            }
        };
        _this.inputRef = function (element) { return (_this.inputSearch = element); };
        _this.state = {
            componentClassName: getComponentClassName(false),
            searchOpen: false,
        };
        window.addEventListener(MENU_GALAXY_EVENT_INPUT, _this.receivedSearchResult);
        return _this;
    }
    /**
     * Handle input search change
     *
     * @param evt
     */
    Search.prototype.handleInputOnChange = function (evt) {
        this.searchString = evt.target.value;
    };
    /**
     * Open or close search bar
     *
     * @param searchOpen
     */
    Search.prototype.toggleSearchComponent = function (searchOpen) {
        this.setState({
            componentClassName: getComponentClassName(!searchOpen),
            searchOpen: !searchOpen,
        });
    };
    /**
     *  Submit search
     *
     * @param searchString
     */
    Search.prototype.submitSearch = function (searchString) {
        var data = searchString;
        if (searchString && searchString !== this.lastSearch) {
            this.lastSearch = searchString;
        }
        else {
            data = undefined;
        }
        var searchSubmitEvent = new CustomEvent('MENU_GALAXY_EVENT', {
            detail: {
                action: 'submit',
                context: 'search',
                data: data,
            },
        });
        this.setState({
            componentClassName: getComponentClassName(this.state.searchOpen, true),
        });
        window.dispatchEvent(searchSubmitEvent);
    };
    Search.prototype.render = function () {
        var placeholder = this.props.placeholder;
        var componentClassName = this.state.componentClassName;
        return (React.createElement("div", { className: componentClassName },
            React.createElement("div", { className: "input-container" },
                React.createElement("input", { ref: this.inputRef, autoFocus: true, type: "text", placeholder: placeholder, onChange: this.handleInputOnChange, onKeyUp: this.handleKeyUp })),
            React.createElement("div", { id: "magnifying-glass", "aria-label": "Lancer la recherche", role: "button", onClick: this.handleClick, tabIndex: 0, onKeyUp: this.handleKeyUp }),
            React.createElement("div", { className: "glxy-loader" })));
    };
    return Search;
}(React.Component));
export default Search;
//# sourceMappingURL=Search.js.map